import { jsx as _jsx } from "react/jsx-runtime";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from 'react-dnd-html5-backend';
import StateKanbanColumn from "@/features/taskState/components/StateKanbanColumn";
const StateKanbanBoard = ({ taskStates, onClickUpdateState, onDeleteState, onSwitchState, }) => {
    return (_jsx(DndProvider, { backend: HTML5Backend, children: _jsx("div", { className: "flex flex-col sm:flex-row sm:overflow-x-auto gap-2 p-2 bg-gray-100", children: taskStates.map((column) => (_jsx(StateKanbanColumn, { state: column, onSwitch: onSwitchState, onEdit: onClickUpdateState, onDelete: onDeleteState, totalItems: taskStates.length }, column.id))) }) }));
};
export default StateKanbanBoard;
